// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test'
		//suggestionPosition: 'left'
	}
};

(function() { // Add this
	BoostPFS.inject(this); // Add this

	/* some code */
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {};

	InstantSearch.prototype.beforeInit = function(id) {
		// Remove the default Instant Search of the theme
		jQ('.live-search-form, .site-header-search-form').removeAttr('data-live-search-form').removeAttr('data-live-search-flydown');
		jQ('input[name="q"]').removeAttr('data-live-search-input');
		jQ('.search-flydown').hide();
		jQ('button.site-header-search-button.button-primary').prop("type", "submit");
		jQ('button.live-search-button.button-primary').prop("type", "submit");
		jQ(document).ready(function() {
			jQ('.live-search-form, .site-header-search-form').off(".search-form");
			if (typeof bcHeaderSearch !== 'undefined') bcHeaderSearch.unload();
		});
	};

    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
        if (this.data.price_max && this.data.price_max > 0) {
          price = Utils.formatMoney(this.data.price_max);
        }
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}
})();